type BillingCycle = "MONTHLY" | "YEARLY";

interface BillingCycleToggleProps {
  value: BillingCycle;
  onChange: (cycle: BillingCycle) => void;
  yearlyDiscount?: string;
}

export function BillingCycleToggle({
  value,
  onChange,
  yearlyDiscount,
}: BillingCycleToggleProps) {
  return (
    <fieldset aria-label="Billing cycle" className="mt-5 text-center">
      <legend className="sr-only">Billing cycle</legend>
      <div className="relative inline-flex items-center select-none rounded-full text-sm font-medium border border-text-primary/[.07] p-1 bg-[#1F1F26]">
        <div
          className="absolute top-1 left-1 w-40 h-8 bg-background-card-hover/80 backdrop-blur-sm rounded-full transition-transform duration-300 ease-in-out"
          style={{
            transform: `translateX(${value === "YEARLY" ? 0 : "100%"})`,
          }}
        ></div>

        <label className="relative flex w-40 h-8 cursor-pointer items-center justify-center gap-1 rounded-full">
          <input
            type="radio"
            name="billing"
            value="YEARLY"
            className="peer sr-only"
            checked={value === "YEARLY"}
            onChange={() => onChange("YEARLY")}
          />
          <span
            className={`transition-colors duration-150 ${
              value === "YEARLY"
                ? "text-text-primary font-extrabold"
                : "text-text-tertiary"
            }`}
          >
            Yearly
          </span>
          {yearlyDiscount && (
            <span className="ml-1 px-[10px] h-5 flex items-center justify-center rounded-full bg-background-body/45 text-xs font-bold text-primary">
              {yearlyDiscount}
            </span>
          )}
        </label>

        <label className="relative flex w-40 h-8 cursor-pointer items-center justify-center gap-1 rounded-full">
          <input
            type="radio"
            name="billing"
            value="MONTHLY"
            className="peer sr-only"
            checked={value === "MONTHLY"}
            onChange={() => onChange("MONTHLY")}
          />
          <span
            className={`transition-colors duration-150 ${
              value === "MONTHLY"
                ? "text-text-primary font-extrabold"
                : "text-text-tertiary"
            }`}
          >
            Monthly
          </span>
        </label>
      </div>
    </fieldset>
  );
}
